import { render, staticRenderFns } from "./TaxEvent.vue?vue&type=template&id=4f6ac699&"
import script from "./TaxEvent.vue?vue&type=script&lang=ts&"
export * from "./TaxEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports